{
  "header": {
    "title": "Perspectivas de líderes",
    "description": "Sumérgete en los comentarios de diferentes líderes",
    "exportButton": "Exportar"
  },
  "emptyState": {
    "company": {
      "title": "No se han recopilado datos aún",
      "description": "¡Tu viaje comienza aquí! Una vez que los empleados empiecen a compartir comentarios durante el primer mes, verás aparecer perspectivas y tendencias."
    },
    "directReports": {
      "title": "No hay reportes directos",
      "description": "No tienes reportes directos asignados, ¡pero aún puedes participar en encuestas y compartir comentarios valiosos!",
      "bottomAction": {
        "label": "Si crees que esto es un error, contacta a tu gerente",
        "helpText": "Texto de ayuda"
      }
    }
  },
  "datePicker": {
    "currentMonth": "Este mes",
    "lastMonth": "Mes pasado",
    "monthCount": "Hace {{monthCount}} meses"
  },
  "leaderDropdown": {
    "triggerLabel": "Líder",
    "searchPlaceholder": "Buscar un líder"
  },
  "columnDropdown": {
    "triggerLabel": "Columnas",
    "options": {
      "showAll": "Mostrar todas las columnas",
      "hideAll": "Ocultar todas las columnas"
    }
  },
  "departmentDropdown": {
    "triggerLabel": "Departamento"
  },
  "tabs": {
    "allReports": "Todos los informes",
    "directReports": "Reportes directos"
  },
  "columns": {
    "leaderName": "Nombre del líder",
    "department": "Departamento",
    "averageScore": "Puntuación promedio",
    "enps": "eNPS",
    "reportCount": "Número de informes",
    "participationRate": "Tasa de participación"
  },
  "loadMoreButton": "Cargando más datos",
  "labels": {
    "leader": "Líder",
    "noResults": "Sin resultados"
  },
  "help": {
    "noResults": "No se encontraron resultados"
  },
  "detailsPage": {
    "header": {
      "name": "Equipo de {{name}}",
      "department": "Equipo de {{department}}",
      "backButton": "Volver a perspectivas de líderes",
      "seeProfileButton": "Ver perfil",
      "exportButton": "Exportar"
    },
    "tabs": {
      "allReports": "Todos los informes",
      "directReports": "Reportes directos"
    },
    "leaderMetrics": {
      "title": "Métricas del líder",
      "category": {
        "enps": {
          "name": "eNPS",
          "helpText": "Texto de ayuda"
        },
        "averageScore": {
          "name": "Puntuación promedio",
          "helpText": "Texto de ayuda"
        },
        "participationRate": {
          "name": "Tasa de participación del equipo",
          "helpText": "Texto de ayuda"
        }
      },
      "chart": {
        "title": "Puntuación de satisfacción laboral"
      }
    },
    "teamMetrics": {
      "title": "Métricas promedio del equipo",
      "scoreTitle": "Equipo de {{name}}",
      "companyAverageTitle": "Promedio de la empresa"
    },
    "keysInsights": {
      "title": "Insights clave",
      "strengths": {
        "title": "Fortalezas",
        "tooltipTitle": "Texto de ayuda"
      },
      "growthAreas": {
        "title": "Áreas de crecimiento",
        "tooltipTitle": "Texto de ayuda"
      }
    },
    "directReport": {
      "title": "Líderes de reportes directos",
      "empty": {
        "title": "No hay líderes de informes directos",
        "description": "Este líder no tiene líderes subordinados, o los datos aún no se han cargado."
      }
    }
  }
}
